import { Anchor } from "./types";

// Capture radius (SCREEN px; the hook divides by zoom) within which an
// alignment guide claims the dragged node. The competition runs on the RAW
// pointer-derived position (React Flow's snapToGrid is off; the grid is
// applied afterwards to whatever no guide captured), so this is a pure
// feel radius — adjacent stops closer than 2×radius split the space
// between them (nearest wins).
export const SNAP_RADIUS = 12;

// Only nodes this close (SCREEN px, box-to-box gap) to the dragged node
// act as alignment sources — alignment is a neighborly gesture; anchors of
// far-away objects capturing the drag reads as noise. The hook divides by
// zoom so the reach looks the same at every zoom level (zoomed out, the
// flow-space reach grows accordingly).
export const MAX_GUIDE_NODE_DISTANCE = 512;

// Rendered guides span just the dragged node and the matched node, plus
// this overhang on each end.
export const GUIDE_OVERHANG = 16;

// Anchor points compared against neighbors when looking for alignment:
// the four edges plus both centers (centers render as dashed guides).
export const ANCHORS: Record<string, Anchor> = {
  top: { orientation: "horizontal", resolve: (_, box) => box.y },
  bottom: {
    orientation: "horizontal",
    resolve: (_, box) => box.y2,
  },
  left: { orientation: "vertical", resolve: (_, box) => box.x },
  right: { orientation: "vertical", resolve: (_, box) => box.x2 },
  centerX: {
    orientation: "vertical",
    resolve: (_, box) => (box.x + box.x2) / 2,
  },
  centerY: {
    orientation: "horizontal",
    resolve: (_, box) => (box.y + box.y2) / 2,
  },
};
